import { render } from "./buyDomain.vue?vue&type=template&id=16fd99c2&scoped=true"
import script from "./buyDomain.vue?vue&type=script&lang=js"
export * from "./buyDomain.vue?vue&type=script&lang=js"

import "./buyDomain.vue?vue&type=style&index=0&id=16fd99c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fd99c2"]])

export default __exports__